'use client'

import {
  Button,
  Emphasized,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

const NotFound = () => (
  <Section className='not-found-section'>
    <OpeningTitle
      size='sm'
      variant='negative'
    >
      404
    </OpeningTitle>
    <Title as='h1'>
      Sembra ci sia stato <br /> un <Emphasized>errore</Emphasized>
    </Title>
    <Paragraph>
      Nulla di cui preoccuparsi, non abbiamo trovato la pagina che stavi
      cercando.{' '}
    </Paragraph>
    <div className='not-found--cta'>
      <Button
        href='/'
        as='a'
        variant='themed'
      >
        Torna alla Homepage
      </Button>
      <Button
        href='/'
        target='_blank'
        variant='secondary'
      >
        Dona ora
      </Button>
    </div>
  </Section>
)

export default NotFound
